/* Styles */
import '@/scss/main.scss'
import '@mdi/font/css/materialdesignicons.css'

/* Core */
import Vue from 'vue'
import Buefy from 'buefy'
import moment from 'moment-timezone'
import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import es from 'vee-validate/dist/locale/es'

/* Router & Store */
import router from './routes/index'
import store from './store'

/* Service Worker */
import './registerServiceWorker'

/* Vue. Main component */
import App from './App.vue'
import CredentialsService from '@/services/CredentialsService.js'

import { isMobile } from 'mobile-device-detect'

/* Vue. Component in recursion */
import AsideMenuList from '@/components/AsideMenuList'
require('moment-precise-range-plugin')

localize('es', es)

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

extend('required', {
  validate (value) {
    return {
      required: true,
      valid: ['', null, undefined].indexOf(value) === -1
    }
  },
  computesRequired: true
})

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

// with typescript
for (let [rule, validation] of Object.entries(rules)) {
  extend(rule, {
    ...validation
  })
}

moment.tz.setDefault('America/Santiago')
require('moment/locale/es')
Vue.use(require('vue-moment'), {
  moment
})

moment.locale('es')
Vue.prototype.moment = moment
Vue.prototype.router = router

/* Collapse mobile aside menu on route change */
router.afterEach(() => {
  if (isMobile) {
    store.commit('asideMobileStateToggle', false)
  } else {
    store.commit('asideMobileStateToggle', true)
  }
})

router.beforeEach(
  (to, from, next) => {
    if (to.matched.some(record => record.meta.authRequired)) {
      if (CredentialsService.isAuthenticated()) {
        next()
      } else {
        next({ path: '/login' })
      }
    } else if (to.matched.some(record => record.meta.onlyGuest)) {
      if (!CredentialsService.isAuthenticated()) {
        next()
      } else {
        next({ path: from.path })
      }
    } else {
      next()
    }
  }
)

Vue.config.productionTip = false

/* These components are used in recursion algorithm */
Vue.component('AsideMenuList', AsideMenuList)

Vue.use(Buefy)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
